module.exports = __webpack_public_path__ + "img/connecting-dot-jam.6212efb6.png";